export const LocationTypes = {
	ROOMS: 'rooms',
	FLOORS: 'floors',
	BUILDINGS: 'buildings'
}